module.exports = function getResource(label) {
    let resources = {
        storeDetails: 'Store Details'
    };

    return resources[label];
};
